import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  sessionConfig = new Subject<ISessionConfig>();
  constructor(private route: ActivatedRoute) {}

  init() {
    this.route.queryParams.subscribe((params) => {
      if (params['agency-id']) {
        this.sessionConfig.next({
          agencyId: params['agency-id'] as number,
          userId: params['user-id'] as number,
          hostedDomain: params['hosted-domain'] as string,
          isNewAgency: params['new-agency']
            ? JSON.parse(params['new-agency'].toLowerCase())
            : false,
          urlParams: params['params'] ? params['params'] : '',
          sessionId: params['session-id'] as string,
        });
      }
    });
  }
}

export interface ISessionConfig {
  agencyId: number;
  userId: number;
  hostedDomain: string;
  isNewAgency: boolean;
  urlParams: string;
  sessionId: string;
}
